import React, { useState, useEffect } from 'react';
import api from '../services/api';

const ComplaintManagement = () => {
  const [stats, setStats] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Carregar estatísticas
  useEffect(() => {
    const loadStats = async () => {
      try {
        const response = await api.get('/complaints/analytics/stats');

        if (response.data && response.data.success) {
          setStats(response.data.stats);
        }
      } catch (error) {
        console.error('Erro ao carregar estatísticas:', error);
      } finally {
        setLoading(false);
      }
    };

    loadStats();
  }, []);

  // Carregar dados do usuário
  useEffect(() => {
    const loadUser = async () => {
      try {
        const response = await api.get('/auth/me');

        if (response.data && response.data.success) {
          setUser(response.data.user);
        }
      } catch (error) {
        console.error('Erro ao carregar usuário:', error);
      }
    };

    loadUser();
  }, []);

  if (loading) {
    return (
      <div className="p-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-7xl mx-auto">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">
          📊 Dashboard Administrativo
        </h1>
        <p className="text-gray-600">
          Visão geral das estatísticas do sistema
        </p>
      </div>

      {/* Estatísticas */}
      {stats && (
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 mb-8">
          <div className="bg-white rounded-lg shadow p-4">
            <div className="text-2xl font-bold text-blue-600">{stats.total_complaints}</div>
            <div className="text-sm text-gray-600">Total de Denúncias</div>
          </div>
          <div className="bg-white rounded-lg shadow p-4">
            <div className="text-2xl font-bold text-yellow-600">{stats.pending}</div>
            <div className="text-sm text-gray-600">Pendentes</div>
          </div>
          <div className="bg-white rounded-lg shadow p-4">
            <div className="text-2xl font-bold text-orange-600">{stats.investigating}</div>
            <div className="text-sm text-gray-600">Em Investigação</div>
          </div>
          <div className="bg-white rounded-lg shadow p-4">
            <div className="text-2xl font-bold text-green-600">{stats.resolved}</div>
            <div className="text-sm text-gray-600">Resolvidas</div>
          </div>
          <div className="bg-white rounded-lg shadow p-4">
            <div className="text-2xl font-bold text-purple-600">{stats.last_30_days}</div>
            <div className="text-sm text-gray-600">Últimos 30 dias</div>
          </div>
        </div>
      )}

      {/* Informação sobre redirecionamento */}
      <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-lg font-medium text-blue-800">
              Gestão de Denúncias Movida
            </h3>
            <div className="mt-2 text-sm text-blue-700">
              <p>
                A funcionalidade completa de gestão de denúncias foi movida para o painel de investigação.
                Para visualizar, editar e gerenciar denúncias individuais, acesse:
              </p>
              <div className="mt-3">
                <a 
                  href="/investigation" 
                  className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  🔍 Ir para Painel de Investigação
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Informações do usuário */}
      {user && (
        <div className="mt-8 bg-gray-50 rounded-lg p-4">
          <h3 className="text-lg font-medium text-gray-900 mb-2">Informações da Sessão</h3>
          <div className="text-sm text-gray-600">
            <p><strong>Usuário:</strong> {user.username || user.email}</p>
            <p><strong>Função:</strong> {user.role}</p>
            <p><strong>Nome:</strong> {user.full_name || 'Não informado'}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ComplaintManagement;
